import { pointInPolygon } from "../../utils/pointInPolygon.js";
import type { Site } from "./site.js";

export const containsPoint = (site: Site, lat: number, long: number): boolean => {
    if (site.polygons && site.polygons[0]) {
        const transformedBoundaries = site.polygons[0].map((p) => [p.lat, p.lng]);
        const point = [lat, long];
        return pointInPolygon(point, transformedBoundaries);
    }
    return false;
};
